var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-container",style:({ height: _vm.height })},[_c('div',{staticClass:"chart-wrap",style:({ maxWidth: _vm.maxWidth })},[_c('div',{staticClass:"chart"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }